var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFitHeight = function SvgFitHeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fitHeight_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fitHeight_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fitHeight_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fitHeight_svg__st1",
    d: "M22 2v20H2V2h20m0-2H2C.9 0 0 .9 0 2v20c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fitHeight_svg__st2",
    d: "m15 6-3-3-3 3M15 18l-3 3-3-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fitHeight_svg__st3",
    d: "M12 3v18"
  })));
};
export default SvgFitHeight;